export const DispositionTypeEnum = Object.freeze({
  success: 'Success',
  fail: 'Fail',
});
